export const steps = [
  {
    name: 'Subscriptions',
    path: '/subscriptions',
    validate: (state) => !!state.subscription, // subscription must be selected
  },
  {
    name: 'Addons',
    path: '/addons',
    validate: (state) => true, 
  },
  {
    name: 'Your Information',
    path: '/your-information',
    validate: (state) =>
      state.formValues?.allValid &&
      ((state.formValues?.allAddonContactsValid && state.formValues?.emailsUnique) || state.addons?.filter(addon => addon.requiresContactInfo).length === 0) &&
      (state.formValues?.allAddonCompaniesValid || state.addons?.filter(addon => addon.requiresCompanyInfo).length === 0),
  },
  {
    name: 'Checkout',
    path: '/checkout',
    validate: (state) => false,
  },
  {
    name: 'Checkout Complete',
    path: '/checkout-complete',
    validate: (state) => false,
  },
  {
    name: 'Activation',
    path: '/activation',
    validate: (state) => false,
  }
];
